import { useEffect, useState } from 'react';

const COARSE_QUERY = '(any-pointer: coarse)';

const getCoarsePointer = () => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(COARSE_QUERY).matches;
};

/** True se il device ha un input touch (tablet incluso, anche > 840px). */
export default function useCoarsePointer() {
  const [isCoarsePointer, setIsCoarsePointer] = useState(getCoarsePointer);

  useEffect(() => {
    const mql = window.matchMedia(COARSE_QUERY);
    const onChange = () => setIsCoarsePointer(mql.matches);
    onChange();
    if (mql.addEventListener) mql.addEventListener('change', onChange);
    else mql.addListener(onChange);
    return () => {
      if (mql.removeEventListener) mql.removeEventListener('change', onChange);
      else mql.removeListener(onChange);
    };
  }, []);

  return isCoarsePointer;
}
